import { IModel, Model } from '@common/models/Model';
import { defaultTo } from 'lodash';

export interface IOrganizationVersionModel extends IModel {
  name: string;
  organizationVersionId: number;
}

export class OrganizationVersionModel
  extends Model
  implements IOrganizationVersionModel
{
  name: string;
  organizationVersionId: number;

  constructor(params: Partial<IOrganizationVersionModel> = {}) {
    super(params);
    const {
      name: _name = '',
      organizationVersionId: _organizationVersionId = 0,
    } = params;
    this.name = defaultTo(params.name, '');
    this.organizationVersionId = defaultTo(params.organizationVersionId, 0);
  }
}
